import React, { useEffect, useState } from "react";
import { FaPlay, FaRandom, FaBuromobelexperte } from "react-icons/fa";
import { IconType } from "react-icons/lib";
import CP_Container from "../ReusableParts/CP_Stuff/CP_Container";
import SCP_Util from "../ReusableParts/CP_Stuff/SCP_Util";
import SpeedControl from "../ReusableParts/CP_Stuff/SpeedControl";
import GetRandomSudokuBoard from "./GetRandomSudokuBoard";
type Props = {
  setStartSolving: React.Dispatch<React.SetStateAction<Boolean>>;
  setProgressSpeed: React.Dispatch<React.SetStateAction<number>>;
  setClear: React.Dispatch<React.SetStateAction<Boolean>>;
  setCurSudoku: React.Dispatch<React.SetStateAction<number[][]>>;
  setDifficulty: React.Dispatch<
    React.SetStateAction<"EASY" | "MEDIUM" | "HARD">
  >;
};

function SudokuControlPanel({
  setStartSolving,
  setProgressSpeed,
  setClear,
  setCurSudoku,
  setDifficulty,
}: Props) {
  const [speed, setSpeed] = useState("50");
  useEffect(() => {
    setProgressSpeed(() => {
      return 1000 - parseInt(speed) * 99;
    });
  }, [speed]);

  const getTitle = (title: String, curIcon: IconType) => {
    return (
      <>
        {React.createElement(curIcon, { cursor: "pointer" })}
        <span
          id="rangeValue"
          style={{
            textAlign: "center",
            fontSize: "0.9rem",
          }}
        >
          {title}
        </span>
      </>
    );
  };
  const SCP_UTIL_OPTIONS = [
    {
      toRender: <>{getTitle("Start", FaPlay)}</>,
      onClick: () => {
        setStartSolving(true);
      },
    },
    {
      toRender: getTitle("Random", FaRandom),
      onClick: () => {
        const temp = GetRandomSudokuBoard();
        setCurSudoku(temp.examples[temp.pos]);
        if (temp.pos == 0) setDifficulty("MEDIUM");
        if (temp.pos == 1) setDifficulty("EASY");
        if (temp.pos == 2) setDifficulty("HARD");
      },
    },
    {
      toRender: getTitle("Clear", FaBuromobelexperte),
      onClick: () => {
        setClear(true);
      },
    },
  ];
  return (
    <CP_Container>
      <>
        <h2 style={{ marginBottom: "2rem", textAlign: "center" }}>
          Sudoku Solver
        </h2>
        <SpeedControl
          speed={speed}
          setSpeed={setSpeed}
          title={"Speed " + speed + "%"}
        />
        <SCP_Util options={SCP_UTIL_OPTIONS} />
      </>
    </CP_Container>
  );
}

export default SudokuControlPanel;
